import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <section className="home-container">
      <div className="home-content">
        <article className="home-text">
          <h3>GV Travels Madurai</h3>
          <h1>
            <span>Cabs</span> Booking
          </h1>
          <p>
          We provide the best customized deals for cab services, outstation trips, tour packages, and taxi hire in Madurai.
          </p>
          <div className="home-buttons">
            <a href="#contact">
              <button className="book-ride-btn">Book Ride</button>
            </a>
          </div>
        </article>
        <figure className="home-image">
          <img src="images/car.png" alt="Red VW Car" />
        </figure>
      </div>
    </section>
  );
};

export default Home;
